<footer class="bg-surface-50 border-t border-subtle">
  <div class="container mx-auto px-6 lg:px-10 py-10 text-center">
    <div class="flex justify-center gap-2 mb-6">
      <a href="https://github.com/vnribeiro" target="_blank" rel="noopener noreferrer" aria-label="GitHub"
        title="GitHub" class="w-10 h-10 rounded-lg border border-subtle flex items-center justify-center text-muted hover:border-accent hover:text-accent transition-all duration-300">
        <i class="fab fa-github text-sm"></i>
      </a>
      <a href="https://linkedin.com/in/vinicius-costa-azevedo-ribeiro" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"
        title="LinkedIn" class="w-10 h-10 rounded-lg border border-subtle flex items-center justify-center text-muted hover:border-accent hover:text-accent transition-all duration-300">
        <i class="fab fa-linkedin text-sm"></i>
      </a>
      <a href="https://instagram.com/ribeirovn_" target="_blank" rel="noopener noreferrer" aria-label="Instagram"
        title="Instagram" class="w-10 h-10 rounded-lg border border-subtle flex items-center justify-center text-muted hover:border-accent hover:text-accent transition-all duration-300">
        <i class="fab fa-instagram text-sm"></i>
      </a>
    </div>
    <p class="text-[10px] text-muted font-mono tracking-wider">
      &copy; {{ getCurrentYear() }} {{ 'footer.title' | translate }}
    </p>
  </div>
</footer>
